'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { Stack } from '../server/layout/Stack/index';
import { Row } from '../server/layout/Row/index';
import { MOTION } from '../system/motion';
import styles from './RailRow.module.css';
export function RailRow(props) {
    const { active, bordered = true, last, padX, padY, gap, leading, title, sub, actions, trailing, } = props;
    const subId = useId();
    const trailingId = useId();
    const hasSub = sub != null;
    const hasTrailing = Boolean(trailing);
    let heading = title;
    if (props.onClick !== undefined) {
        const disabled = props.disabled === true;
        const describedBy = [hasSub ? subId : null, hasTrailing ? trailingId : null]
            .filter((id) => id !== null)
            .join(' ');
        // `aria-disabled` rather than `disabled`: a natively disabled button drops
        // keyboard focus to <body> when it's disabled while focused (e.g. a picker
        // row that goes pending the moment Enter selects it).
        heading = (_jsx("button", { type: "button", className: styles.target, onClick: disabled ? undefined : props.onClick, "aria-disabled": disabled || undefined, "aria-describedby": describedBy === '' ? undefined : describedBy, "aria-pressed": props['aria-pressed'], "aria-current": props['aria-current'], children: title }));
    }
    const interactive = props.onClick !== undefined;
    return (_jsxs(Row, { align: "center", wrap: false, gap: gap ?? 'md', className: interactive ? `${styles.row} ${styles.interactive}` : styles.row, "data-active": active || undefined, style: {
            padding: `var(--space-${padY ?? 'md'}) var(--space-${padX ?? 'lg'})`,
            borderLeft: `var(--border-thicker) solid ${active ? 'var(--primary)' : 'transparent'}`,
            borderBottom: bordered && !last ? '1px solid var(--border)' : 'none',
            transition: MOTION.transition,
        }, children: [leading, (heading != null || hasSub || actions != null) && (_jsxs(Stack, { gap: "xs", style: { flex: 1, minWidth: 0 }, children: [heading, hasSub && _jsx("div", { id: subId, children: sub }), actions != null && _jsx("div", { children: actions })] })), hasTrailing && _jsx("div", { id: trailingId, style: { flexShrink: 0 }, children: trailing })] }));
}
//# sourceMappingURL=RailRow.js.map